import { Sparkles, Eye } from "lucide-react";

export default function MissionVision() {
  return (
    <section id="mission" className="py-24 bg-[#F2EFEB] relative overflow-hidden" data-testid="mission-section">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="overline text-[#E07A5F]">Our Words</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3">
            Mission & Vision
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl p-8 lg:p-10 border border-border" data-testid="mission-card">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-[#1B4332] text-white flex items-center justify-center">
                <Sparkles className="w-6 h-6" />
              </div>
              <h3 className="font-serif-display text-3xl text-[#1B4332]">Our Mission</h3>
            </div>
            <blockquote className="font-serif-display text-xl text-[#222B26] leading-snug italic border-l-2 border-[#E07A5F] pl-4">
              "To serve as a catalyst for positive change — empowering children, youth, and
              women to overcome socioeconomic barriers and unlock their full potential through
              education, skill-building, and holistic development."
            </blockquote>
            <div className="mt-6 space-y-4 text-sm text-[#5C6661] leading-relaxed">
              <p>
                At EDS Foundation, our mission is to ensure equitable access to quality
                education and comprehensive development opportunities for every individual,
                regardless of background or circumstance.
              </p>
              <p>
                We implement a wide range of programs — including scholarships, school support,
                educational workshops, and community welfare initiatives — that go beyond academic
                learning to nurture critical thinking, leadership, resilience, and ethical values.
              </p>
              <p>
                We are equally committed to the health and well-being of the communities we
                serve. From supporting frontline health workers like ASHA workers to advocating
                for better infrastructure in rural and tea garden areas, our mission extends
                wherever there is a need for dignified support and meaningful change.
              </p>
              <p>
                Collaboration is central to our mission. By building strong alliances with
                district authorities, government agencies, and fellow non-profit organizations,
                we amplify our reach and work toward systemic, sustainable solutions.
              </p>
            </div>
          </div>

          <div className="bg-[#1B4332] text-white rounded-2xl p-8 lg:p-10" data-testid="vision-card">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-[#E07A5F] text-white flex items-center justify-center">
                <Eye className="w-6 h-6" />
              </div>
              <h3 className="font-serif-display text-3xl">Our Vision</h3>
            </div>
            <blockquote className="font-serif-display text-xl leading-snug italic border-l-2 border-[#F4A261] pl-4">
              "A just and equitable society where every child grows with dignity, every woman
              leads with confidence, and every community thrives with opportunity."
            </blockquote>
            <div className="mt-6 space-y-4 text-sm text-stone-200 leading-relaxed">
              <p>
                EDS Foundation envisions a world where poverty is not a barrier to potential,
                where education opens doors for all, and where communities are empowered to
                shape their own futures.
              </p>
              <p>
                We see an Assam — and ultimately an India — where grassroots organizations,
                government, and corporate partners unite to build systems that leave no one
                behind.
              </p>
              <p>
                We strive to be a trusted pillar of social transformation: recognized not only
                for the programs we run, but for the lives we change, the hope we restore, and
                the future we help build — one child, one woman, one community at a time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
